import React, { memo } from "react";
import { WrappedFieldMetaProps } from "redux-form";

import { RequiredMark } from "components";
import { DatePickerInputProps } from "types";

import styles from "../formFields/formField.module.scss";

type DatePickerWithLabelWrapperProps = {
	input?: DatePickerInputProps;
	meta?: WrappedFieldMetaProps;
	label: string;
	labelClass?: string;
	showRequiredMark?: boolean;
	renderDatePicker: (
		input?: DatePickerInputProps,
		meta?: WrappedFieldMetaProps,
	) => JSX.Element;
};

const DatePickerWithLabelWrapper = ({
	input,
	meta,
	label,
	labelClass,
	showRequiredMark,
	renderDatePicker,
}: DatePickerWithLabelWrapperProps) => {
	const component = renderDatePicker(input, meta);
	const { touched, error } = meta || {};

	const errorMessage = touched && error && (
		<span className={styles.spanError}>{error}</span>
	);

	return (
		<>
			{label && (
				<label className={labelClass}>
					{label}
					{showRequiredMark && <RequiredMark />}
				</label>
			)}
			{component}
			{errorMessage}
		</>
	);
};

export default memo(DatePickerWithLabelWrapper);
